import { Box, BoxProps } from "@chakra-ui/react";
import { FaFacebookSquare } from "react-icons/fa";

export const href = "https://www.facebook.com/MyAreaHub";

export type Facebook_T = BoxProps;

export const Facebook = (props: Facebook_T) => {
  return (
    <Box
      as={FaFacebookSquare}
      aria-label="Facebook"
      fill="facebook"
      {...props}
    />
  );
};
